import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '../State';
import { PersonTypeActionTypes } from '../State/actions/personType.actions';
import { BaseEntityResolver } from './resolver.helper';
import { getPersonTypesFetched } from '../State/selectors/personType.selectors';

@Injectable({
    providedIn: 'root',
})
export class PersonTypeResolver extends BaseEntityResolver {
    constructor(store: Store<State>) {
        super(getPersonTypesFetched, PersonTypeActionTypes.GetPersonTypeRequest(), store);
    }
}
